<template>
    <v-form ref="accountEditForm" v-model="editFormValid" lazy-validation @submit.prevent="validate">
        <v-container fluid>
            <v-row class="align-center">
                <v-col :cols="isDesktop ? 4 : 'auto'" class="d-flex">
                        <v-avatar class="user-pic" v-if="userDetails.avatar_url" :class="isDesktop ? 'ml-auto' : ''">
                          <img  :src="userDetails.avatar_url" :alt="userDetails.name">
                          <v-btn fab color="red white--text"  
                          @click="removeProfileImage" 
                          :size="80"
                          absolute 
                          right
                          :x-offset="-10" 
                          top 
                          x-small><v-icon>mdi-close</v-icon></v-btn>
                        </v-avatar>
                        <v-avatar v-else :class="isDesktop ? 'ml-auto' : ''">
                          <v-icon color="grey" size="50" >mdi-account-circle</v-icon>
                        </v-avatar>
                </v-col>
                <v-col cols="8">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="title">{{user.name}}</v-list-item-title>
                      <v-list-item-subtitle>
                        <span @click="cropperDialog = true" class="textLinks--text" v-if="userDetails.avatar_url">Change Profile Photo</span>
                        <span @click="cropperDialog = true" class="textLinks--text" v-else>Add profile Photo</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
            </v-row>

            <row class="align-center">
              <template v-slot:colLeft>
                <label for="" :class="isDesktop ? 'ml-auto' : ''">Name</label>
              </template>
              <template v-slot:colRight>
                <v-text-field ref="name" 
                v-model="name" 
                :rules="genericRules.nameRules"
                required 
                color="dark" 
                outlined 
                dense
                hide-details="auto" 
                clearable 
                clear-icon="mdi-refresh">
                    <template slot="append">
                        <v-icon class="success-icon" color="success">mdi-check</v-icon>
                        <v-icon class="error-icon" color="error">mdi-close</v-icon>
                    </template>
                </v-text-field>
              </template>
            </row>

            <row class="align-center">
              <template v-slot:colLeft>
                <label for="" :class="isDesktop ? 'ml-auto' : ''">Username</label>
              </template>
              <template v-slot:colRight>
                <v-text-field ref="username" 
                v-model="username" 
                :rules="genericRules.usernameRules"
                :error-messages="userNameErrorMessages" 
                :success="userNameSuccess" 
                :loading="usernameChecking"
                @input="checkUsername"
                required 
                color="grey" 
                outlined 
                dense
                hide-details="auto" 
                clearable 
                clear-icon="mdi-refresh">
                    <template slot="append">
                        <v-icon class="success-icon" color="success">mdi-check</v-icon>
                        <v-icon class="error-icon" color="error">mdi-close</v-icon>
                    </template>
                </v-text-field>
              </template>
            </row>

            <row class="align-center">
              <template v-slot:colLeft>
                <label for="" :class="isDesktop ? 'ml-auto' : ''">Email</label>
              </template>
              <template v-slot:colRight>
                <v-text-field ref="email" 
                v-model="email" 
                :rules="genericRules.emailRules"
                :error-messages="emailErrorMessages" 
                :success="emailSuccess" 
                :loading="emailChecking"
                @input="checkEmail"
                required 
                color="grey" 
                outlined 
                dense
                hide-details="auto" 
                clearable 
                clear-icon="mdi-refresh">
                    <template slot="append">
                        <v-icon class="success-icon" color="success">mdi-check</v-icon>
                        <v-icon class="error-icon" color="error">mdi-close</v-icon>
                    </template>
                </v-text-field>
              </template>
            </row>

            <row class="align-center">
              <template v-slot:colLeft>
                <label for="" :class="isDesktop ? 'ml-auto' : ''">Role</label>
              </template>
              <template v-slot:colRight>
                <v-select
                  v-model="role"
                  :items="accountTypes"
                  item-text="label"
                  item-color="grey"
                  color="grey"
                  outlined
                  dense
                  hide-details="auto"
                  clearable
                  clear-icon="mdi-refresh"
                ></v-select>
              </template>
            </row>

            <row class="align-center">
              <template v-slot:colLeft>
                <label for="" :class="isDesktop ? 'ml-auto' : ''">Phone</label>
              </template>
              <template v-slot:colRight>
                <v-text-field
                v-model="phone"
                :rules="genericRules.phoneRules"
                color="grey"
                ref="phone"
                outlined 
                dense
                hide-details="auto"
                maxlength="10"
                clearable 
                clear-icon="mdi-refresh">
                </v-text-field>
              </template>
            </row>

            <row class="align-start">
              <template v-slot:colLeft>
                <label for="" :class="isDesktop ? 'ml-auto' : ''">Address</label>
              </template>
              <template v-slot:colRight>
                <v-textarea v-model="address"
                color="grey"
                ref="address"
                outlined 
                dense
                hide-details="auto"
                ></v-textarea>
              </template>
            </row>

            <v-row>
              <v-col cols="12" class="d-flex">
                <v-spacer></v-spacer>
                <v-btn type="submit" color="blue darken-1 white--text" :disabled="!editFormValid || updatingAccount" 
                :loading="updatingAccount"
                @click="validate">Save</v-btn>
              </v-col>
            </v-row>

        </v-container>
        
        <v-dialog v-model="cropperDialog" max-width="450">
          <v-card>
            <v-container fluid>
              
              <image-cropper 
              :loading="croppingAndUploading"
              :originalImage="avatarUrl" :croppedImageUniqueTo="'user-' + userDetails.id" @cropped="onImageCrop"></image-cropper>
            </v-container>
            <v-btn absolute right top icon @click="cropperDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card>
        </v-dialog>
        <reauthenticate-window v-model="authenticateDialog" v-if="authenticateDialog" @verfied="onVerification"></reauthenticate-window>
    </v-form>
</template>
<style scoped>
  .user-pic {
    overflow: visible;
  }
  .user-pic > button {
    right: -5px;
  }
</style>
<script>
import ApiService from "@/base/api/api.service"
import imageCropper from "@/components/widgets/widget-image-cropper.vue"
import row from "@/components/rows/row-two-col--format-a.vue"
import formMixins from "@/mixins/mixin-forms"
import fieldCheckMixins from "@/mixins/mixin-field-checks"
import reauthenticateWindow from "@/components/notifiers/reauthenticate-dialog"

import {
  ADD_PROFILE_PIC,
  REMOVE_PROFILE_PIC,
  UPDATE_ACCOUNT
} from "@/store/actions.type"

export default {
    props: {
      userDetails: Object
    },
    mixins: [formMixins, fieldCheckMixins],
    components: {
        imageCropper,
        row,
        reauthenticateWindow
    },
    data(){
      return {
        editFormValid: false,
        avatarUrl: this.userDetails.avatar_url || '',
        name: this.userDetails.name,
        email: this.userDetails.email,
        address: this.userDetails.location,
        username: this.userDetails.username,
        role: this.userDetails.account_type,
        phone: this.userDetails.phone,
        accountTypes: this.$store.state.account.accountTypes.slice(),
        cropperDialog: false,
        croppingAndUploading: false,
        authenticateDialog: false,
        updatingAccount: false
      }
    },

    computed: {
      // Main data format to send 
      sendingData() {
        return {
          name: this.name,
          username: this.username,
          email: this.email,
          account_type: this.role,
          location: this.address,
          phone: this.phone
        }
      }
    },

    methods: {

        // Form validation function
        validate() {
            if(this.updatingAccount) return

            if (this.$refs.accountEditForm.validate()) {
                if(this.sendingData.name === this.userDetails.name && 
                  this.sendingData.username === this.userDetails.username &&
                  this.sendingData.email === this.userDetails.email &&
                  this.sendingData.account_type === this.userDetails.account_type &&
                  this.sendingData.location === this.userDetails.location &&
                  this.sendingData.phone == this.userDetails.phone ) return

                // Checking for changes in email, if exists show re authentication dialog
                if(this.sendingData.email === this.userDetails.email) {
                  this.sendUpdate()
                } else {
                  this.authenticateDialog = true
                }
            }
        },

        // After Verification update email if changes present
        onVerification() {
          ApiService.firebaseUpdateUserEmail(this.sendingData.email)
          .then(() => {
            this.sendUpdate()
          })
        },

        // Sending update function
        sendUpdate() {
          this.updatingAccount = true
          this.$store.dispatch(UPDATE_ACCOUNT, this.sendingData)
          .then(() => {
            this.updatingAccount = false
          })
        },

        // On image crop success event
        onImageCrop(file) {
          this.croppingAndUploading = true
          // remove already existing one
          this.$store.dispatch(REMOVE_PROFILE_PIC, {
            name: this.userDetails.avatar_file_name
          })
          // Adding new one
          .then(() => {
            return this.$store.dispatch(ADD_PROFILE_PIC, file)
          })
          .then((url) => {
            this.croppingAndUploading = false
            this.cropperDialog = false
            this.$store.dispatch(UPDATE_ACCOUNT, {
              avatar_url: url,
              avatar_file_name: file.name
            })
          })
          .catch(() => {
            this.croppingAndUploading = false
          })
        },

        // For removing pic
        removeProfileImage() {
          this.$store.dispatch(REMOVE_PROFILE_PIC, {
            name: this.userDetails.avatar_file_name
          })
          .then(() => {
            this.$store.dispatch(UPDATE_ACCOUNT,{
              avatar_url: '',
              avatar_file_name: ''
            })
          })
        }
    }
}
</script>